// src/components/Admin/IcrReviewModal.js
import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress } from '@mui/material';

export default function IcrReviewModal({ open, onClose, onSave, reportContent, clientName }) {
    const [editedContent, setEditedContent] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (reportContent) {
            setEditedContent(reportContent);
        }
    }, [reportContent]);

    const handleSave = async () => {
        setIsSaving(true);
        try {
            await onSave(editedContent);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Initial Company Research for: {clientName}</DialogTitle>
            <DialogContent>
                <TextField
                    multiline
                    fullWidth
                    rows={20}
                    value={editedContent}
                    onChange={(e) => setEditedContent(e.target.value)}
                    variant="outlined"
                    sx={{ mt: 2, '& .MuiInputBase-root': { fontSize: '0.9rem' } }}
                    placeholder="AI-generated report will appear here for review and editing..."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isSaving}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" disabled={isSaving}>
                    {isSaving ? <CircularProgress size={24} /> : "Save Report to Client Profile"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}